import type { Instance } from 'mobx-state-tree';
import { types } from 'mobx-state-tree';

export const ExperimentsModel = types
  .model('Experiments')
  .props({
    list: types.optional(types.array(types.number), []),
  })
  .actions((self) => ({
    bookmark: (experimentId: number) => {
      if (self.list.includes(experimentId)) {
        self.list.remove(experimentId);
      } else {
        self.list.push(experimentId);
      }
    },
  }));

export interface IExperimentsModel extends Instance<typeof ExperimentsModel> {}
